import React, { Component } from "react";
import Dialog from "../../../dialogs/dialog";
import DialogInput from "../../../dialogs/input";
import DatePickerBox from "../../../dialogs/datepicker";
import LanguageInput from "../../../dialogs/languagesinput";
import SelectConfigInput from "../../../dialogs/selectconfig";

import ClientsDiffusorsList from "../../tables/clientsdiffusors/clientsdiffusorslist";
import SeriesList from "../../tables/series/serieslist";
import SelectAssets from "../selectassets/selectassets";

import SimplePopup from "../../../../components/bases/popup/simplePopup";

import {getCurrentUserDatas} from "../../../../utils/software"

import { apiCreateProjects,apiDeleteProjects, apiUpdateProjects } from "../../../../utils/apis";


import StateInput from "../../../dialogs/stateinput";
import TableInput from "../../../dialogs/tableinput";

import { apiGetClientsList, apiGetDiffusorsList, apiGetSeriesList } from "../../../../utils/apis";


class ProjectForm extends Dialog
{
  constructor(props) 
  {
    super(props);
    this.state.title= {en:"Error !!!",  fr:"Erreur !!!",}

    this.state.msgname ="";
    this.state.msgmail="";

    this.state.displayDialogClients=false;
    this.state.displayDialogDiffusors = false;
    this.state.displayDialogSeries = false;
    this.state.displaySelectAssets = false;

    this.state.displayDeletePopup = false;


    this.state.formulaire ={};

    if (this.props.action != "add")
    {
        
        this.state.formulaire.id = this.props.formulaire.pjid;
        this.state.formulaire.idbase = this.props.formulaire.pjidbase;
        this.state.formulaire.client = this.props.formulaire.pjclient;
        this.state.formulaire.diffusor = this.props.formulaire.pjdiffusor;
        this.state.formulaire.user = this.props.formulaire.pjuser;
        this.state.formulaire.serie = this.props.formulaire.pjserie;
        this.state.formulaire.season = this.props.formulaire.pjseason;
        this.state.formulaire.episode = this.props.formulaire.pjepisode;
        this.state.formulaire.lot = this.props.formulaire.pjlot;

        this.state.formulaire.orititle = this.props.formulaire.pjorititle;
        this.state.formulaire.tratitle = this.props.formulaire.pjtratitle;

        this.state.formulaire.isan = this.props.formulaire.pjisan;
        this.state.formulaire.em = this.props.formulaire.pjem;
        this.state.formulaire.sherlock = this.props.formulaire.pjsherlock;

        this.state.formulaire.orilang = this.props.formulaire.pjorilang;

        this.state.formulaire.config = this.props.formulaire.pjconfig;
        this.state.formulaire.createdate = this.props.formulaire.pjcreatedate;
        this.state.formulaire.updatedate = this.props.formulaire.pjupdatedate;
        this.state.formulaire.deliverydate = this.props.formulaire.pjdeliverydate;

        this.state.formulaire.comments = this.props.formulaire.pjcomments;

        this.state.formulaire.status = this.props.formulaire.pjstatus;
        this.state.formulaire.notes = this.props.formulaire.pjnotes;
        this.state.formulaire.duree = this.props.formulaire.pjduree;
    }
    else
    {

        this.state.formulaire.id = 0;
        this.state.formulaire.idbase = "";
        this.state.formulaire.client = 0;
        this.state.formulaire.diffusor = 0;
        this.state.formulaire.user = 0;
        this.state.formulaire.serie = 0;
        this.state.formulaire.season = 0;
        this.state.formulaire.episode = 0;
        this.state.formulaire.lot = "";

        this.state.formulaire.orititle = "";
        this.state.formulaire.tratitle = "";

        this.state.formulaire.isan = "";
        this.state.formulaire.em = "";
        this.state.formulaire.sherlock = "";

        this.state.formulaire.orilang = "fr-FR";

        this.state.formulaire.config = 0;
        this.state.formulaire.createdate = this.getCurrentDate();
        this.state.formulaire.updatedate = this.getCurrentDate();
        this.state.formulaire.deliverydate = this.getCurrentDate();

        this.state.formulaire.comments = "";

        this.state.formulaire.status=1;
        this.state.formulaire.notes="";
        this.state.formulaire.duree="";




    }


    switch (this.props.action)
    {
        case "view":
            this.state.title= {en:"View Project",  fr:"Visualiser un Projet",}
            break;
        case "add":
            this.state.title= {en:"Create Project",  fr:"Nouveau Projet",}
            break;
        case "edit":
            this.state.title= {en:"Edit Project",  fr:"Modifier un Projet",}
            break;
        case "delete":
            this.state.title= {en:"Delete Project",  fr:"Supprimer un Projet",}
            break;
    }


    
    


    var buttons = [];
    if ((this.props.action === "view") || (this.props.action === "edit")) buttons.push({type:"text", disabled:false,text:{fr:"Assets",en:"Assets"},key:"assets"})

    if (this.props.action === "delete")buttons.push({type:"text", disabled:false,text:{fr:"Supprimer",en:"Delete"},key:"delete"})
    buttons.push({type:"back", disabled:false});
    if (this.props.action !== "delete") buttons.push({type:"ok", disabled:false});


    this.state.buttons = buttons;

    this.idRef = React.createRef();
    this.idbaseRef = React.createRef();
    this.clientRef = React.createRef();
    this.diffusorRef = React.createRef();
    this.userRef = React.createRef();
    this.serieRef = React.createRef();
    this.seasonRef = React.createRef();
    this.episodeRef = React.createRef();
    this.lotRef = React.createRef();

    this.orititleRef = React.createRef();
    this.tratitleRef = React.createRef();

    this.isanRef = React.createRef();
    this.emRef = React.createRef();
    this.sherlockRef = React.createRef();

    this.orilangRef = React.createRef();

    this.configRef = React.createRef();
    this.createdateRef = React.createRef();
    this.updatedateRef = React.createRef();
    this.deliverydateRef = React.createRef();

    this.commentsRef = React.createRef();

    
    this.statusRef = React.createRef();
    this.notesRef = React.createRef();
    this.dureeRef = React.createRef();


    this.handleButton =  this.handleButton.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.retourapi = this.retourapi.bind(this);
    this.onQuit = this.onQuit.bind(this)

    this.onselectClient = this.onselectClient.bind(this)
    this.onselectDiffuseur = this.onselectDiffuseur.bind(this)
    this.onselectSerie = this.onselectSerie.bind(this)

    this.onValidFormClients = this.onValidFormClients.bind(this)
    this.onValidFormSeries = this.onValidFormSeries.bind(this)
    this.onValidFormDiffuseurs = this.onValidFormDiffuseurs.bind(this)
    this.onValidFormAssets = this.onValidFormAssets.bind(this)
    
    this.onDelete = this.onDelete.bind(this)
    this.onDontDelete = this.onDontDelete.bind(this)
  }

    onQuit()
    {
      this.props.onvalidform({ret:false});
    }

    onValid()
    {
      
      this.handleButton("ok");
    }



    getCurrentDate = () => {
        const today = new Date();
      
        const year = today.getFullYear(); // Année AAAA
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois (01-12)
        const day = String(today.getDate()).padStart(2, '0'); // Jour (01-31)
      
        return `${year}/${month}/${day}`;
      };

  retourapi(ret)
  {
 
    
    var retour = {};
    retour.action = this.props.action;
    retour.ok = ret.ret;
    if (ret.ret )
    {
      retour.id = ret.id;
      retour.msg = ret.msg;
    }
    this.props.onvalidform(retour);
  }


  isPositiveInteger(value) {
    const num = Number(value);
    return Number.isInteger(num) && num >= 0;
  }


  onDelete()
  {
    var formulaire = {};
    formulaire.pjid = this.props.formulaire.pjid;
    apiDeleteProjects(formulaire, this.retourapi);      
    

  }
  onDontDelete()
  {
    this.setState ({displayDeletePopup:false})
  }

  handleButton(buttonkey)
  {
    
    
    switch(buttonkey)
    {

       case "assets":
        this.cancelKey = true;
        this.setState({displaySelectAssets: true});
        return;

       case "ok":

          if (this.props.action === "view")
          {
                this.onQuit();
                return;

          }

          var formulaire = {};

          

          formulaire.pjidbase = this.idbaseRef.current.getValue();
          formulaire.pjorititle = this.orititleRef.current.getValue();


          formulaire.pjclient = this.clientRef.current.getValue();
          formulaire.pjdiffusor = this.diffusorRef.current.getValue();


        if (this.props.action === "add")
            formulaire.pjuser = getCurrentUserDatas().id;
        else
            formulaire.pjuser = this.props.formulaire.pjuser;

        


          formulaire.pjserie = this.serieRef.current.getValue();
          
          formulaire.pjseason = this.seasonRef.current.getValue();
          formulaire.pjepisode = this.episodeRef.current.getValue();
          formulaire.pjlot = this.lotRef.current.getValue();
  
          
          formulaire.pjtratitle = this.tratitleRef.current.getValue();
  
          formulaire.pjisan = this.isanRef.current.getValue();
          formulaire.pjem = this.emRef.current.getValue();
          formulaire.pjsherlock = this.sherlockRef.current.getValue();
  
          formulaire.pjorilang = this.orilangRef.current.getValue();
  
          formulaire.pjconfig = parseInt(this.configRef.current.getValue());
          formulaire.pjcreatedate = this.createdateRef.current.getValue();
          formulaire.pjupdatedate = this.updatedateRef.current.getValue();
          formulaire.pjdeliverydate = this.deliverydateRef.current.getValue();
  
          formulaire.pjcomments = this.commentsRef.current.getValue();
          
          formulaire.pjstatus = parseInt(this.statusRef.current.getValue());
          formulaire.pjnotes = this.notesRef.current.getValue();
          formulaire.pjduree = this.dureeRef.current.getValue();

          
          var errname="";
          var errseason="";
          var errepisode="";
          if (formulaire.pjorititle == "") errname=this.context.language=="fr"?"Zone obligatoire.":"Required field.";
          this.orititleRef.current.setErrorMsg(errname);

          if (formulaire.pjepisode == "")
            {
                formulaire.pjepisode = "0";
                this.episodeRef.current.setValue("0");
            }

            if (formulaire.pjseason == "")
          {
            formulaire.pjseason = "0";
            this.seasonRef.current.setValue("0");
          }

  
           if (this.isPositiveInteger(formulaire.pjseason))
           {
                formulaire.pjseason = parseInt(formulaire.pjseason);
                this.seasonRef.current.setValue(formulaire.pjseason.toString());
           }
           else
                errseason=this.context.language=="fr"?"Zone numérique uniquement.":"Numbers only.";


            if (this.isPositiveInteger(formulaire.pjepisode))
            {
                formulaire.pjepisode = parseInt(formulaire.pjepisode);
                this.episodeRef.current.setValue(formulaire.pjepisode.toString());
            }
            else
                errepisode=this.context.language=="fr"?"Zone numérique uniquement.":"Numbers only.";
         

            this.seasonRef.current.setErrorMsg(errseason);
           this.episodeRef.current.setErrorMsg(errepisode);

          if ((errname != "") || (errepisode !=="") || (errseason !==""))return;

          if (this.props.action == "add")
          {
            formulaire.pjid = 0;
            apiCreateProjects(formulaire, this.retourapi);      
          }


          

          if (this.props.action == "edit")
          {
            formulaire.pjid = this.props.formulaire.pjid;
            
              apiUpdateProjects(formulaire, this.retourapi);      
          }
            

          break;


      case "back":
        this.onQuit();
        return;

      case "delete":
        
        this.setState ({displayDeletePopup:true})
        break;
    }

  }

  
  handleOnChange()
  {

  }


  onselectSerie()
  {
    this.cancelKey = true;
    this.setState({displayDialogSeries:true})
  }
  onselectClient(lastvalue)
  {
    this.cancelKey = true;
    this.setState({displayDialogClients:true})
  }
  onselectDiffuseur()
  {
    this.cancelKey = true;
    this.setState({displayDialogDiffusors:true})
    
  }

  onValidFormClients(datas)
  {
    this.cancelKey = false;
    if (!datas.ret)
        this.setState({displayDialogClients:false})
    else

    {
        
        this.setState({displayDialogClients:false})
        this.clientRef.current.setValue(datas.clid)
    }

    this.clientRef.current.componentMustRefresh();

  }
  onValidFormDiffuseurs(datas)
  {
    this.cancelKey = false;
    if (!datas.ret)
        this.setState({displayDialogDiffusors:false})
    else
    {
        
        this.setState({displayDialogDiffusors:false})
        this.diffusorRef.current.setValue(datas.diid)
    }
    this.diffusorRef.current.componentMustRefresh();
}

  onValidFormAssets(datas)
  {
    this.cancelKey = false;
    this.setState({displaySelectAssets:false})
  }

  onValidFormSeries(datas)
  {
    this.cancelKey = false;
    if (!datas.ret)
        this.setState({displayDialogSeries:false})
    else
    {
        
        this.setState({displayDialogSeries:false})
        this.serieRef.current.setValue(datas.seid)
    }
    this.serieRef.current.componentMustRefresh();

  }

  render()
  {
    var ser=0,cli=0,dif=0;

    if (this.diffusorRef.current)
        dif = this.diffusorRef.current.getValue();
    if (this.clientRef.current)
        cli =this.clientRef.current.getValue();    
    if (this.serieRef.current)
        ser = this.serieRef.current.getValue();

    var addtables = []
   
    if (this.state.displayDialogClients)
      addtables.push(<ClientsDiffusorsList current={cli} select={true} onvalidform={this.onValidFormClients} closebutton = {true} zindex={2} display = {this.state.displayDialogClients} table="CLIENTS"/>)

    if (this.state.displayDialogDiffusors)
        addtables.push(<ClientsDiffusorsList current={dif} select={true} onvalidform={this.onValidFormDiffuseurs} closebutton = {true} zindex={2} display = {this.state.displayDialogDiffusors} table="DIFFUSEURS"/>)
  
    if (this.state.displayDialogSeries)
        addtables.push(<SeriesList current={ser}  select = {true} onvalidform={this.onValidFormSeries} closebutton = {true} zindex={2} display = {this.state.displayDialogSeries} />)


    if (this.state.displaySelectAssets)
        addtables.push(<SelectAssets  
            onvalidform={this.onValidFormAssets} 
            closebutton = {true} zindex={2} 
            pjid={this.props.formulaire.pjid}
            display = {this.state.displaySelectAssets} 
            />)



    var readOnly = (this.props.action === "delete");
    const userdatas = getCurrentUserDatas();
    var readOnly2 = true;
    if (!readOnly)
    {
        if ((userdatas.droits &  4) !== 0)
        {
            readOnly = false;
            readOnly2 = false;
        }
        else
        {
            if (this.state.formulaire.sherlock.trim() !=="")
            {
            readOnly = true;
            readOnly2 = true;
            }
    
        }
    }


    if ((userdatas.droits &  1) !== 0) // dans tous les cas
    {
        readOnly = true;
        readOnly2 = true;
    }
        


    const widtha = 350;
    const widthb = 350;

    const titleDeletePopup = {"fr":"Suppression d'un projet.","en":"Delete Projet."}
    const textDeletePopup = {"fr":"Voulez-vous vraiment supprimer ce projet ? La suppression entrainera aussi la suppression des assets associés.","en":"Do you really want de delete this project and and there assets ?"}
    const bouton1Delete = {"fr":"Supprimer","en":"Delete"}
    const bouton2DontDelete = {"fr":"Abandon","en":"Cancel"}



    const retour =
    (
        <div style={{textAlign:"left"}}>
        <table width={widtha + widthb}>

            <tr>        

                <td >
                    <DialogInput
                    value = {this.state.formulaire.orititle}
                    disabled={false}
                    autoFocus = {true}
                    ref = {this.orititleRef}
                    onChange =  {this.handleOnChange}
                    readOnly = {readOnly}
                    width = "350px"
                    errmsg={this.state.msgname}
                    title = {this.context.language=="fr"?"Titre Original":"Original Title"}
                    />
                </td>

                <td>
                    <DialogInput
                    value = {this.state.formulaire.idbase}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.idbaseRef}
                    readOnly = {readOnly2}
                    width = "100px"
                    title = {this.context.language=="fr"?"ID Base":"Base ID"}
                    />
                </td>              

            </tr>


            <tr>

                <td>
                    <DialogInput
                    value = {this.state.formulaire.tratitle}
                    disabled={false}
                    autoFocus = {false}
                    ref = {this.tratitleRef}
                    onChange =  {this.handleOnChange}
                    readOnly = {readOnly}
                    width = "350px"
                    errmsg={this.state.msgname}
                    title = {this.context.language=="fr"?"Titre Traduit":"Translated Title"}
                    />
                </td>

                <td>
                    <DialogInput
                    value = {this.state.formulaire.em}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.emRef}
                    readOnly = {readOnly}
                    width = "100px"
                    title = {this.context.language=="fr"?"Numéro E.M.":"E.M."}
                    />
                </td>              

            </tr>



            <tr>

                <td>
                    <TableInput
                    value = {this.state.formulaire.client}
                    api = {apiGetClientsList}
                    tooltip = {{fr:"Rechercher ou créer un client.",en:"Search ou create a client."}}
                    unselect =  {this.context.language=="fr"?"Non précisé.":"Not Set."}

                    readOnly = {readOnly}
                    tableid ="clid"
                    tablename = "clname"
                    tableimage = "climage"
                    onselect = {this.onselectClient}

                    disabled={false}
                    autoFocus = {false}
                    ref = {this.clientRef}
                    
                    width = {350}
                    title = {this.context.language=="fr"?"Client":"Client"}
                    />
                </td>

                <td>
                    <DialogInput
                    value = {this.state.formulaire.sherlock}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.sherlockRef}
                    readOnly = {readOnly2}
                    
                    width = "180px"
                    title = {this.context.language=="fr"?"ID Sherlock":"Sherlock ID"}
                    />
                </td>              

            </tr>

            <tr>

                <td>
                    <TableInput
                    value = {this.state.formulaire.diffusor}
                    api = {apiGetDiffusorsList}

                    tableid ="diid"
                    tablename = "diname"
                    tableimage = "diimage"
                    onselect = {this.onselectDiffuseur}
                    readOnly ={readOnly}
                    unselect =  {this.context.language=="fr"?"Non précisé.":"Not Set."}
                    tooltip = {{fr:"Rechercher ou créer un diffuseur.",en:"Search ou create a diffusor."}}
                    disabled={false}
                    autoFocus = {false}
                    ref = {this.diffusorRef}

                    width = {350}
                    title = {this.context.language=="fr"?"Diffuseur":"Diffusor"}
                    />
                </td>

                <td>
                    <DialogInput
                    value = {this.state.formulaire.isan}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.isanRef}
                    readOnly = {readOnly}
                    width = "100px"
                    title = {this.context.language=="fr"?"N° ISAN":"ISAN Number"}
                    />
                </td>              

            </tr>


            <tr>

                <td>
                    <TableInput
                    value = {this.state.formulaire.serie}
                    api = {apiGetSeriesList}

                    tableid ="seid"
                    tablename = "sename"
                    tableimage = "seimage"
                    onselect = {this.onselectSerie}
                    readOnly ={readOnly}
                    tooltip = {{fr:"Rechercher ou créer une série.",en:"Search ou create a serie."}}
                    disabled={false}
                    autoFocus = {false}
                    ref = {this.serieRef}

                    unselect =  {this.context.language=="fr"?"Non précisée.":"Not Set."}
                    
                    width = {350}
                    title = {this.context.language=="fr"?"Série":"Serie"}
                    />
                </td>

                <td>
                    <DialogInput
                    value = {this.state.formulaire.lot}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.lotRef}
                    readOnly = {readOnly}
                    width = "100px"
                    title = {this.context.language=="fr"?"Lot":"Lot"}
                    />
                </td>              

            </tr>

            <tr>
                <td>
                    <DialogInput
                    value = {this.state.formulaire.season}
                    align = "center"
                    disabled={false}
                    autoFocus = {false}
                    ref = {this.seasonRef}
                    onChange =  {this.handleOnChange}
                    readOnly = {readOnly}
                    width = "70px"
                    title = {this.context.language=="fr"?"Saison":"Season"}
                    />
                </td>

                <td>
                    <LanguageInput
                    value = {this.state.formulaire.orilang}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.orilangRef}
                    readOnly = {readOnly}
                    width = "350px"
                    title = {this.context.language=="fr"?"Langue Originale":"Original Language"}
                    />
                </td>              

            </tr>


            <tr>
                <td>
                    <DialogInput
                    value = {this.state.formulaire.episode}
                    disabled={false}
                    autoFocus = {false}
                    align = "center"
                    ref = {this.episodeRef}
                    onChange =  {this.handleOnChange}
                    readOnly = {readOnly}
                    width = "70px"
                    title = {this.context.language=="fr"?"Episode":"Episode"}
                    />
                </td>

                <td>
                    <SelectConfigInput
                    coid = {this.state.formulaire.config}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.configRef}
                    readOnly = {readOnly}
                    width = {350}
                    title = {this.context.language=="fr"?"Configuration":"Configuration"}
                    />
                </td>              

            </tr>


            <tr>
                <td>

                    <DatePickerBox
                    value = {this.state.formulaire.createdate}
                    disabled={false}
                    autoFocus = {false}
                    ref = {this.createdateRef}
                    readOnly = {readOnly2}
                    onChange =  {this.handleOnChange}
                    width = "110px"
                    title = {this.context.language=="fr"?"Date de création":"Creation Date"}
                    />
                </td>

                <td>
                    <DatePickerBox
                    value = {this.state.formulaire.updatedate}
                    disabled={false}
                    autoFocus = {false}
                    ref = {this.updatedateRef}
                    readOnly = {readOnly2}
                    onChange =  {this.handleOnChange}
                    width = "110px"
                    title = {this.context.language=="fr"?"Dernière Mise à Jour":"Update Date"}
                    />
                </td>              

            </tr>

            <tr>
                <td>
                    <DatePickerBox
                    value = {this.state.formulaire.deliverydate}
                    disabled={false}
                    autoFocus = {false}
                    ref = {this.deliverydateRef}
                    onChange =  {this.handleOnChange}
                    readOnly = {readOnly}
                    width = "110px"
                    title = {this.context.language=="fr"?"Date de livraison":"Delivery Date"}
                    />
                </td>

                <td>
                    <DialogInput
                    value = {this.state.formulaire.comments}
                    disabled={false}
                    nbline = {3}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.commentsRef}
                    readOnly = {readOnly}
                    width = "300px"
                    title = {this.context.language=="fr"?"Commentaires":"Comments"}
                    />
                </td>              

            </tr>


            <tr>
              <td>
                    <DialogInput
                    value = {this.state.formulaire.notes}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.notesRef}
                    readOnly = {readOnly}
                    width = "300px"
                    title = {this.context.language=="fr"?"Projet/Notes":"Projects/Notes"}
                    />
            </td>
                <td>
                    <DialogInput
                    value = {this.state.formulaire.duree}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.dureeRef}
                    readOnly = {readOnly2}
                    width = "100px"
                    title = {this.context.language=="fr"?"Durée":"Lenght"}
                    />
                </td>              

            </tr>

            <tr>
                <td>
                    <StateInput
                    value = {this.state.formulaire.status}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    ref = {this.statusRef}
                    readOnly = {readOnly}
                    width = "300px"
                    title = {this.context.language=="fr"?"Etat : ":"State : "}
                    />
                </td>              

            </tr>



            </table>

            {addtables}

            <SimplePopup 
                display={this.state.displayDeletePopup} 
                title={titleDeletePopup} 
                text={textDeletePopup} 
                onCancel={this.onDontDelete}
                buttons ={
                    [
                        {text:bouton1Delete,onclick:this.onDelete},
                        {text:bouton2DontDelete,onclick:this.onDontDelete}
                    ]} />

            </div>

            

    )

    return super.render(retour);
  }


}
ProjectForm.defaultProps = 
{
    selectButton: false,
    zindex:2,
    closebutton: true,
    displaySelectAssets: false,
}




export default ProjectForm;